import { MDBAlert, MDBBtn, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';
import React, { forwardRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { deleteAccContacts } from '../../../apiclients/streamsapi_bridge';

const DeleteAccContact = forwardRef((props, ref) => {
    const [internalError, setInternalError] = useState(false);
    const { t, i18n } = useTranslation();
    // const [isloading, setIsloading] = useState(false);
    const navigate = useNavigate();

    async function removeThisContact(e) {
        try {
            setInternalError(false);
            props.setIsloading(true);
            let update = {
                reqid: 114,
                id: props.contactId,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            }
            let deleteGrpReponse = await deleteAccContacts(update);
            setTimeout(() => { props.setIsloading(false) }, 1000);
            let delInfo = await deleteGrpReponse.json();

            if (delInfo.status == 'success') {
                localStorage.setItem("s_message", delInfo.contacts_info);
                props.onClose();

                window.location.href = "/contactslanding";

            } else {
                localStorage.setItem("f_message", delInfo.contacts_info);
                window.location.href = "/contactslanding";
            }
        } catch (e) {
            console.log(`Unable to process Request :Internal server Error:!`);
            setInternalError(true);
        }
    }
    return (
        <>
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
            >Internal Server Error</MDBAlert>)}
            <div>
                <span className="phrecording">{t("RemoveContacttxt")}</span>
            </div>
            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeThisContact(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
            <div style={{ display: "none" }}>
						<button ref={ref} onClick={(e) =>  removeThisContact(e)}>
							{t("add")}</button>
					</div>
            {/* {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )} */}
        </>
    );
});

export default DeleteAccContact
